import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UtcOffset2q1jzx5thduw7 as UtcOffset,
  UtcOffset17lxgyhnn4rny as UtcOffset_0,
} from '../UtcOffset.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective } from '../internal/format/FieldFormatDirective.mjs';
import {
  Padding_ZERO_getInstance165tawgk9tdj7 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance3jytkjkv2jvr6 as Padding_SPACE_getInstance,
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
} from './DateTimeFormat.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  offsetHours$defaultkbnzeiu5kz92 as offsetHours$default,
  offsetMinutesOfHour$default10ls43d3hs3kk as offsetMinutesOfHour$default,
  offsetSecondsOfMinute$default1bdialvaf1bc0 as offsetSecondsOfMinute$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithUtcOffset30ws1ntcash0j as WithUtcOffset,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  optional3j6ywsx1pxeh6 as optional,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure,
  SignedFormatStructure3e3cmtnnik1yf as SignedFormatStructure,
} from '../internal/format/FormatStructure.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_OFFSET() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp0 = ISO_OFFSET$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_OFFSET', 0, tmp, _get_ISO_OFFSET_$ref_70d0nn(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_OFFSET$delegate;
var ISO_OFFSET_BASIC$delegate;
var FOUR_DIGIT_OFFSET$delegate;
function get_emptyIncompleteUtcOffset() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  return emptyIncompleteUtcOffset;
}
var emptyIncompleteUtcOffset;
var UtcOffsetFieldContainerClass;
function UtcOffsetFieldContainer() {
  if (UtcOffsetFieldContainerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'UtcOffsetFieldContainer');
    UtcOffsetFieldContainerClass = $;
  }
  return UtcOffsetFieldContainerClass;
}
var IncompleteUtcOffsetClass;
function IncompleteUtcOffset() {
  if (IncompleteUtcOffsetClass === VOID) {
    class $ {
      constructor(offsetIsNegative, offsetHours, offsetMinutesOfHour, offsetSecondsOfMinute) {
        offsetIsNegative = offsetIsNegative === VOID ? null : offsetIsNegative;
        offsetHours = offsetHours === VOID ? null : offsetHours;
        offsetMinutesOfHour = offsetMinutesOfHour === VOID ? null : offsetMinutesOfHour;
        offsetSecondsOfMinute = offsetSecondsOfMinute === VOID ? null : offsetSecondsOfMinute;
        this.offsetIsNegative_1 = offsetIsNegative;
        this.offsetHours_1 = offsetHours;
        this.offsetMinutesOfHour_1 = offsetMinutesOfHour;
        this.offsetSecondsOfMinute_1 = offsetSecondsOfMinute;
      }
      set_offsetIsNegative_lg0w0f_k$(_set____db54di) {
        this.offsetIsNegative_1 = _set____db54di;
      }
      get_offsetIsNegative_5z1gsb_k$() {
        return this.offsetIsNegative_1;
      }
      set_offsetHours_5m57ic_k$(_set____db54di) {
        this.offsetHours_1 = _set____db54di;
      }
      get_offsetHours_yn9exf_k$() {
        return this.offsetHours_1;
      }
      set_offsetMinutesOfHour_lotc9b_k$(_set____db54di) {
        this.offsetMinutesOfHour_1 = _set____db54di;
      }
      get_offsetMinutesOfHour_p1w44e_k$() {
        return this.offsetMinutesOfHour_1;
      }
      set_offsetSecondsOfMinute_kv6vfj_k$(_set____db54di) {
        this.offsetSecondsOfMinute_1 = _set____db54di;
      }
      get_offsetSecondsOfMinute_mpvmxe_k$() {
        return this.offsetSecondsOfMinute_1;
      }
      toUtcOffset_loe12c_k$() {
        var sign = this.offsetIsNegative_1 === true ? -1 : 1;
        var tmp0_safe_receiver = this.offsetHours_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = imul(tmp0_safe_receiver, sign);
        }
        var tmp_0 = tmp;
        var tmp1_safe_receiver = this.offsetMinutesOfHour_1;
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = imul(tmp1_safe_receiver, sign);
        }
        var tmp_2 = tmp_1;
        var tmp2_safe_receiver = this.offsetSecondsOfMinute_1;
        var tmp_3;
        if (tmp2_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_3 = imul(tmp2_safe_receiver, sign);
        }
        return UtcOffset(tmp_0, tmp_2, tmp_3);
      }
      populateFrom_543lw3_k$(offset) {
        this.offsetIsNegative_1 = offset.totalSeconds_1 < 0;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = offset.totalSeconds_1;
        var totalSecondsAbs = abs(this_0);
        this.offsetHours_1 = totalSecondsAbs / 3600 | 0;
        this.offsetMinutesOfHour_1 = (totalSecondsAbs / 60 | 0) % 60 | 0;
        this.offsetSecondsOfMinute_1 = totalSecondsAbs % 60 | 0;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof IncompleteUtcOffset()) {
          tmp_2 = this.offsetIsNegative_1 == other.offsetIsNegative_1;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.offsetHours_1 == other.offsetHours_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.offsetMinutesOfHour_1 == other.offsetMinutesOfHour_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.offsetSecondsOfMinute_1 == other.offsetSecondsOfMinute_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.offsetIsNegative_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.offsetHours_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var tmp_0 = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_1 = this.offsetMinutesOfHour_1;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
        var tmp_1 = tmp_0 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_2 = this.offsetSecondsOfMinute_1;
        var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        return tmp_1 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
      }
      copy_1tks5_k$() {
        return new (IncompleteUtcOffset())(this.offsetIsNegative_1, this.offsetHours_1, this.offsetMinutesOfHour_1, this.offsetSecondsOfMinute_1);
      }
      toString() {
        var tmp0_safe_receiver = this.offsetIsNegative_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = tmp0_safe_receiver ? '-' : '+';
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_0 = tmp1_elvis_lhs == null ? ' ' : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.offsetHours_1;
        var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
        var tmp3_elvis_lhs = this.offsetMinutesOfHour_1;
        var tmp_2 = toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs);
        var tmp4_elvis_lhs = this.offsetSecondsOfMinute_1;
        return tmp_0 + tmp_1 + ':' + tmp_2 + ':' + toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
      }
    }
    initMetadataForClass($, 'IncompleteUtcOffset', IncompleteUtcOffset, VOID, [UtcOffsetFieldContainer()]);
    IncompleteUtcOffsetClass = $;
  }
  return IncompleteUtcOffsetClass;
}
var UtcOffsetWholeHoursDirectiveClass;
function UtcOffsetWholeHoursDirective() {
  if (UtcOffsetWholeHoursDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().totalHoursAbs_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetWholeHoursDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetWholeHoursDirective');
    UtcOffsetWholeHoursDirectiveClass = $;
  }
  return UtcOffsetWholeHoursDirectiveClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      build_dzztnl_k$(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (UtcOffsetFormat())(builder.build_1k0s4u_k$());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.actualBuilder_1 = actualBuilder;
      }
      get_actualBuilder_7qypdo_k$() {
        return this.actualBuilder_1;
      }
      addFormatStructureForOffset_puuf83_k$(structure) {
        this.actualBuilder_1.add_b6pdwl_k$(structure);
      }
      createEmpty_8k9z67_k$() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).appendAlternativeParsingImpl_9hljk3_k$ = appendAlternativeParsingImpl;
    protoOf($).appendOptionalImpl_725ywl_k$ = appendOptionalImpl;
    protoOf($).chars_pe6iqb_k$ = chars;
    protoOf($).build_1k0s4u_k$ = build;
    protoOf($).offsetHours_tq5sq0_k$ = offsetHours;
    protoOf($).offsetHours$default_fnv9sq_k$ = offsetHours$default;
    protoOf($).offsetMinutesOfHour_nthfst_k$ = offsetMinutesOfHour;
    protoOf($).offsetMinutesOfHour$default_4t7b2p_k$ = offsetMinutesOfHour$default;
    protoOf($).offsetSecondsOfMinute_yjq3ot_k$ = offsetSecondsOfMinute;
    protoOf($).offsetSecondsOfMinute$default_8v7lk1_k$ = offsetSecondsOfMinute$default;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithOffsetBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var UtcOffsetFormatClass;
function UtcOffsetFormat() {
  if (UtcOffsetFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.actualFormat_1 = actualFormat;
      }
      get_actualFormat_d0ha3y_k$() {
        return this.actualFormat_1;
      }
      intermediateFromValue_qn9rt5_k$(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteUtcOffset())();
        this_0.populateFrom_543lw3_k$(value);
        return this_0;
      }
      intermediateFromValue_816pep_k$(value) {
        return this.intermediateFromValue_qn9rt5_k$(value instanceof UtcOffset_0() ? value : THROW_CCE());
      }
      valueFromIntermediate_yfy6o_k$(intermediate) {
        return intermediate.toUtcOffset_loe12c_k$();
      }
      valueFromIntermediate_60ox3m_k$(intermediate) {
        return this.valueFromIntermediate_yfy6o_k$(intermediate instanceof IncompleteUtcOffset() ? intermediate : THROW_CCE());
      }
      get_emptyIntermediate_lysuyr_k$() {
        return get_emptyIncompleteUtcOffset();
      }
    }
    initMetadataForClass($, 'UtcOffsetFormat');
    UtcOffsetFormatClass = $;
  }
  return UtcOffsetFormatClass;
}
function UtcOffsetFieldContainer$_get_offsetIsNegative_$ref_v5gok2() {
  return constructCallableReference((p0) => p0.get_offsetIsNegative_5z1gsb_k$(), 1, 0, 45);
}
function UtcOffsetFieldContainer$_set_offsetIsNegative_$ref_h7e0jq() {
  return constructCallableReference((p0, p1) => {
    p0.set_offsetIsNegative_lg0w0f_k$(p1);
    return Unit_instance;
  }, 2, 0, 46);
}
var OffsetFields$sign$1Class;
function OffsetFields$sign$1() {
  if (OffsetFields$sign$1Class === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = UtcOffsetFieldContainer$_get_offsetIsNegative_$ref_v5gok2();
        tmp.isNegative_1 = new (PropertyAccessor())(getPropertyCallableRef('offsetIsNegative', 1, tmp_0, tmp_1, UtcOffsetFieldContainer$_set_offsetIsNegative_$ref_h7e0jq()));
      }
      get_isNegative_i24zqw_k$() {
        return this.isNegative_1;
      }
      isZero_ip1qpa_k$(obj) {
        var tmp;
        var tmp_0;
        var tmp0_elvis_lhs = obj.get_offsetHours_yn9exf_k$();
        if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) === 0) {
          var tmp1_elvis_lhs = obj.get_offsetMinutesOfHour_p1w44e_k$();
          tmp_0 = (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) === 0;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var tmp2_elvis_lhs = obj.get_offsetSecondsOfMinute_mpvmxe_k$();
          tmp = (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) === 0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      isZero_yccjay_k$(obj) {
        return this.isZero_ip1qpa_k$((!(obj == null) ? isInterface(obj, UtcOffsetFieldContainer()) : false) ? obj : THROW_CCE());
      }
    }
    initMetadataForClass($);
    OffsetFields$sign$1Class = $;
  }
  return OffsetFields$sign$1Class;
}
function UtcOffsetFieldContainer$_get_offsetHours_$ref_elsov2() {
  return constructCallableReference((p0) => p0.get_offsetHours_yn9exf_k$(), 1, 0, 47);
}
function UtcOffsetFieldContainer$_set_offsetHours_$ref_4i2hci() {
  return constructCallableReference((p0, p1) => {
    p0.set_offsetHours_5m57ic_k$(p1);
    return Unit_instance;
  }, 2, 0, 48);
}
function UtcOffsetFieldContainer$_get_offsetMinutesOfHour_$ref_712kt() {
  return constructCallableReference((p0) => p0.get_offsetMinutesOfHour_p1w44e_k$(), 1, 0, 49);
}
function UtcOffsetFieldContainer$_set_offsetMinutesOfHour_$ref_ka4bon() {
  return constructCallableReference((p0, p1) => {
    p0.set_offsetMinutesOfHour_lotc9b_k$(p1);
    return Unit_instance;
  }, 2, 0, 50);
}
function UtcOffsetFieldContainer$_get_offsetSecondsOfMinute_$ref_xrmftp() {
  return constructCallableReference((p0) => p0.get_offsetSecondsOfMinute_mpvmxe_k$(), 1, 0, 51);
}
function UtcOffsetFieldContainer$_set_offsetSecondsOfMinute_$ref_virwvd() {
  return constructCallableReference((p0, p1) => {
    p0.set_offsetSecondsOfMinute_kv6vfj_k$(p1);
    return Unit_instance;
  }, 2, 0, 52);
}
var OffsetFieldsClass;
function OffsetFields() {
  if (OffsetFieldsClass === VOID) {
    class $ {
      constructor() {
        OffsetFields_instance = this;
        var tmp = this;
        tmp.sign_1 = new (OffsetFields$sign$1())();
        var tmp_0 = this;
        var tmp_1 = KMutableProperty1();
        var tmp_2 = UtcOffsetFieldContainer$_get_offsetHours_$ref_elsov2();
        var tmp0_accessor = new (PropertyAccessor())(getPropertyCallableRef('offsetHours', 1, tmp_1, tmp_2, UtcOffsetFieldContainer$_set_offsetHours_$ref_4i2hci()));
        var tmp1_sign = this.sign_1;
        tmp_0.totalHoursAbs_1 = new (UnsignedFieldSpec())(tmp0_accessor, 0, 18, VOID, 0, tmp1_sign);
        var tmp_3 = this;
        var tmp_4 = KMutableProperty1();
        var tmp_5 = UtcOffsetFieldContainer$_get_offsetMinutesOfHour_$ref_712kt();
        var tmp0_accessor_0 = new (PropertyAccessor())(getPropertyCallableRef('offsetMinutesOfHour', 1, tmp_4, tmp_5, UtcOffsetFieldContainer$_set_offsetMinutesOfHour_$ref_ka4bon()));
        var tmp1_sign_0 = this.sign_1;
        tmp_3.minutesOfHour_1 = new (UnsignedFieldSpec())(tmp0_accessor_0, 0, 59, VOID, 0, tmp1_sign_0);
        var tmp_6 = this;
        var tmp_7 = KMutableProperty1();
        var tmp_8 = UtcOffsetFieldContainer$_get_offsetSecondsOfMinute_$ref_xrmftp();
        var tmp0_accessor_1 = new (PropertyAccessor())(getPropertyCallableRef('offsetSecondsOfMinute', 1, tmp_7, tmp_8, UtcOffsetFieldContainer$_set_offsetSecondsOfMinute_$ref_virwvd()));
        var tmp1_sign_1 = this.sign_1;
        tmp_6.secondsOfMinute_1 = new (UnsignedFieldSpec())(tmp0_accessor_1, 0, 59, VOID, 0, tmp1_sign_1);
      }
    }
    initMetadataForObject($, 'OffsetFields');
    OffsetFieldsClass = $;
  }
  return OffsetFieldsClass;
}
var OffsetFields_instance;
function OffsetFields_getInstance() {
  if (OffsetFields_instance === VOID)
    new (OffsetFields())();
  return OffsetFields_instance;
}
function offsetHours(padding) {
  return this.addFormatStructureForOffset_puuf83_k$(new (SignedFormatStructure())(new (BasicFormatStructure())(new (UtcOffsetWholeHoursDirective())(padding)), true));
}
function offsetMinutesOfHour(padding) {
  return this.addFormatStructureForOffset_puuf83_k$(new (BasicFormatStructure())(new (UtcOffsetMinuteOfHourDirective())(padding)));
}
function offsetSecondsOfMinute(padding) {
  return this.addFormatStructureForOffset_puuf83_k$(new (BasicFormatStructure())(new (UtcOffsetSecondOfMinuteDirective())(padding)));
}
var AbstractWithOffsetBuilderClass;
function AbstractWithOffsetBuilder() {
  if (AbstractWithOffsetBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithOffsetBuilder', VOID, VOID, [WithUtcOffset()]);
    AbstractWithOffsetBuilderClass = $;
  }
  return AbstractWithOffsetBuilderClass;
}
var UtcOffsetMinuteOfHourDirectiveClass;
function UtcOffsetMinuteOfHourDirective() {
  if (UtcOffsetMinuteOfHourDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().minutesOfHour_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetMinuteOfHourDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetMinuteOfHourDirective');
    UtcOffsetMinuteOfHourDirectiveClass = $;
  }
  return UtcOffsetMinuteOfHourDirectiveClass;
}
var UtcOffsetSecondOfMinuteDirectiveClass;
function UtcOffsetSecondOfMinuteDirective() {
  if (UtcOffsetSecondOfMinuteDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = OffsetFields_getInstance().secondsOfMinute_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof UtcOffsetSecondOfMinuteDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'UtcOffsetSecondOfMinuteDirective');
    UtcOffsetSecondOfMinuteDirectiveClass = $;
  }
  return UtcOffsetSecondOfMinuteDirectiveClass;
}
function isoOffset(_this__u8e3s4, zOnZero, useSeparator, outputMinute, outputSecond) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  // Inline function 'kotlin.require' call
  if (!(outputMinute.compareTo_30rs7w_k$(outputSecond) >= 0)) {
    var message = 'Seconds cannot be included without minutes';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  if (zOnZero) {
    optional(_this__u8e3s4, 'Z', ($this$optional) => {
      var tmp = [isoOffset$lambda$lambda];
      alternativeParsing($this$optional, tmp, ($this$alternativeParsing) => {
        isoOffset$appendIsoOffsetWithoutZOnZero($this$alternativeParsing, outputMinute, useSeparator, outputSecond);
        return Unit_instance;
      });
      return Unit_instance;
    });
  } else {
    isoOffset$appendIsoOffsetWithoutZOnZero(_this__u8e3s4, outputMinute, useSeparator, outputSecond);
  }
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  WhenToOutput_NEVER_instance = new (WhenToOutput())('NEVER', 0);
  WhenToOutput_IF_NONZERO_instance = new (WhenToOutput())('IF_NONZERO', 1);
  WhenToOutput_ALWAYS_instance = new (WhenToOutput())('ALWAYS', 2);
}
var WhenToOutput_NEVER_instance;
var WhenToOutput_IF_NONZERO_instance;
var WhenToOutput_ALWAYS_instance;
var WhenToOutputClass;
function WhenToOutput() {
  if (WhenToOutputClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'WhenToOutput');
    WhenToOutputClass = $;
  }
  return WhenToOutputClass;
}
function outputIfNeeded(_this__u8e3s4, whenToOutput, format) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  switch (whenToOutput.ordinal_1) {
    case 0:
      break;
    case 1:
      optional(_this__u8e3s4, VOID, ($this$optional) => {
        format($this$optional);
        return Unit_instance;
      });
      break;
    case 2:
      format(_this__u8e3s4);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function ISO_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.build_dzztnl_k$(ISO_OFFSET$delegate$lambda$lambda);
}
function ISO_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.chars_pe6iqb_k$('z');
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.offsetHours$default_fnv9sq_k$();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.offsetMinutesOfHour$default_4t7b2p_k$();
  optional($this$optional, VOID, ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.offsetSecondsOfMinute$default_8v7lk1_k$();
  return Unit_instance;
}
function _get_ISO_OFFSET_$ref_70d0nn() {
  return constructCallableReference(() => get_ISO_OFFSET(), 0, 0, 53);
}
function ISO_OFFSET_BASIC$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.build_dzztnl_k$(ISO_OFFSET_BASIC$delegate$lambda$lambda);
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = [ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$alternativeParsing.chars_pe6iqb_k$('z');
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  optional($this$alternativeParsing, 'Z', ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.offsetHours$default_fnv9sq_k$();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.offsetMinutesOfHour$default_4t7b2p_k$();
  optional($this$optional, VOID, ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_OFFSET_BASIC$delegate$lambda$lambda$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$optional.offsetSecondsOfMinute$default_8v7lk1_k$();
  return Unit_instance;
}
function FOUR_DIGIT_OFFSET$delegate$lambda() {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  var tmp = Companion_instance;
  return tmp.build_dzztnl_k$(FOUR_DIGIT_OFFSET$delegate$lambda$lambda);
}
function FOUR_DIGIT_OFFSET$delegate$lambda$lambda($this$build) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  $this$build.offsetHours$default_fnv9sq_k$();
  $this$build.offsetMinutesOfHour$default_4t7b2p_k$();
  return Unit_instance;
}
function isoOffset$appendIsoOffsetWithoutZOnZero(_this__u8e3s4, $outputMinute, $useSeparator, $outputSecond) {
  _this__u8e3s4.offsetHours$default_fnv9sq_k$();
  outputIfNeeded(_this__u8e3s4, $outputMinute, ($this$outputIfNeeded) => {
    var tmp;
    if ($useSeparator) {
      char($this$outputIfNeeded, _Char___init__impl__6a9atx(58));
      tmp = Unit_instance;
    }
    $this$outputIfNeeded.offsetMinutesOfHour$default_4t7b2p_k$();
    outputIfNeeded($this$outputIfNeeded, $outputSecond, ($this$outputIfNeeded) => {
      var tmp;
      if ($useSeparator) {
        char($this$outputIfNeeded, _Char___init__impl__6a9atx(58));
        tmp = Unit_instance;
      }
      $this$outputIfNeeded.offsetSecondsOfMinute$default_8v7lk1_k$();
      return Unit_instance;
    });
    return Unit_instance;
  });
}
function isoOffset$lambda$lambda($this$alternativeParsing) {
  _init_properties_UtcOffsetFormat_kt__9r9ddw();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(122));
  return Unit_instance;
}
function WhenToOutput_IF_NONZERO_getInstance() {
  static_init();
  return WhenToOutput_IF_NONZERO_instance;
}
function WhenToOutput_ALWAYS_getInstance() {
  static_init();
  return WhenToOutput_ALWAYS_instance;
}
var properties_initialized_UtcOffsetFormat_kt_6y9jku;
function _init_properties_UtcOffsetFormat_kt__9r9ddw() {
  if (!properties_initialized_UtcOffsetFormat_kt_6y9jku) {
    properties_initialized_UtcOffsetFormat_kt_6y9jku = true;
    ISO_OFFSET$delegate = lazy(ISO_OFFSET$delegate$lambda);
    ISO_OFFSET_BASIC$delegate = lazy(ISO_OFFSET_BASIC$delegate$lambda);
    FOUR_DIGIT_OFFSET$delegate = lazy(FOUR_DIGIT_OFFSET$delegate$lambda);
    emptyIncompleteUtcOffset = new (IncompleteUtcOffset())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  WhenToOutput_ALWAYS_getInstance as WhenToOutput_ALWAYS_getInstancetn5gw5hc9q6,
  WhenToOutput_IF_NONZERO_getInstance as WhenToOutput_IF_NONZERO_getInstance1w5745layokcx,
  Companion_instance as Companion_instance2q34pamd1k2w7,
  get_ISO_OFFSET as get_ISO_OFFSET1wt81dckmqhlf,
  isoOffset as isoOffset2t9o0yqcdt3uh,
};
//endregion

//# sourceMappingURL=UtcOffsetFormat.mjs.map
